import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '././assets/lang/en.json';
import ar from "././assets/lang/ar.json";
import LanguageDetector from 'i18next-browser-languagedetector';
const resources = {
   en:{ translation :en},
    ar:{
         translation :
        ar
 
     }
}

i18n
.use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: "en",
    interpolation: {
      escapeValue: false
    },
    react:{
        useSuspense:false
    }
  });


export default i18n;